import _ from 'lodash';
import { AfterContentInit, Component, DestroyRef, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {  filter, map } from 'rxjs/operators';
import { SharedService } from 'app/virtual-event/services/shared.service';


import { selectCampaignReport, selectOrgUser } from '../../features/dashboard.selectors';
import { loadCampaignReport } from '../../features/dashboard.actions';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { DashboardService } from 'app/dashboard/services/dashboard.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
  selector: 'app-dashboard-swiper',
  templateUrl: './dashboard-swiper.component.html',
  styleUrls: ['./dashboard-swiper.component.scss']
})
export class DashboardSwiperComponent implements OnInit, OnDestroy, AfterContentInit {
  destroyRef = inject(DestroyRef)
  @ViewChild('swiper') swiperRef: ElementRef;
  
  public activeCampaigns = []
  public mostRaisedCampaigns = []
  public campaigns = []
  public activeBtn;
  public showSwiperContainer
  public takeUntilSubject: Subject<any> = new Subject();
  public config = {};

  public orgUser = null;
  public orgUser$ = this.store.pipe(
    select(selectOrgUser),
    filter(user => !_.isNull(user)),
    filter((user: any) => {
      const { orgUser } = this;
      if(orgUser === null) {
        return true;
      }
      const { id: previousUserId, orgId: previousOrgId } = orgUser.loggedInUser || orgUser;
      const { id: currentUserId, orgId: currentOrgId } = user.loggedInUser || user;
      return previousUserId === currentUserId && previousOrgId === currentOrgId ? false: true;
    })
  );

  public showSeeAll$ = this.orgUser$.pipe(
    map((user) => {
      this.orgUser = user;
      const { access } = user.loggedInUser || {
        access: [1]
      };
      const { length } = _.intersection([1,2,4], access);
      return length > 0;
    })
  );

  public campaigns$ = this.store.pipe(
    select(selectCampaignReport),
    takeUntilDestroyed(this.destroyRef)
  ).subscribe(campignReport=>{
    this.campaigns = campignReport
    if(this.campaigns){
      if(this.campaigns.length != 0 ){
        this.showSwiperContainer = true
          setTimeout(()=>{
           new window['Swiper'](this.swiperRef.nativeElement, this.config).update();
          })
         }else{
        this.showSwiperContainer = false
      }
    }

})

  constructor(
    private store: Store,
    private sharedService: SharedService,
    private router: Router,
    private  dashboardService: DashboardService
  ) { }

  ngOnInit(): void {
    const { token } = this.sharedService;
    if(token) {
      this.getCampaignsMTD()
    }

    this.config = {
      navigation: {
        nextEl: '#next',
        prevEl: '#prev'
      },
      width: 160,
      spaceBetween: 20,
      slidesPerView: 1,
    }
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

  getCampaignImageUrl(campaign) {
    return campaign.campaignData.imageUrl || "../../images/org_logo_default_v2.svg";
  }


  getCampaignsMTD(){

    var startDate = Math.floor(Math.floor((new Date(new Date().setDate(1)).setHours(0,0,0)/1000)))
    var endDate = Math.floor(new Date(new Date().setHours(0,0,0)).getTime()/1000) + 24*60*60 - 1
    if(this.activeBtn != 'mtd'){
      this.store.dispatch({
        type:loadCampaignReport.type,
        payload:{
          token:this.sharedService.token,
          startDate,
          endDate
        }
      })
    }
    this.activeBtn = 'mtd'
  }

  getCampaignsYTD(){

    const now = new Date();
    const yearStart = new Date(now.getFullYear(), 0, 1);
    const yearStartTimestamp = Math.floor(yearStart.getTime() / 1000);

    var startDate = yearStartTimestamp
    var endDate = Math.floor(new Date(new Date().setHours(0,0,0)).getTime()/1000) + 24*60*60 - 1
    if(this.activeBtn != 'ytd'){
      this.store.dispatch({
        type:loadCampaignReport.type,
        payload:{
          token:this.sharedService.token,
          startDate,
          endDate
        }
      })
    }
    this.activeBtn = 'ytd'
  }
  
  getCampaignsLastMonth(){
    const lastMonth = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
    const startUnixTimestamp = Math.floor(lastMonth.getTime() / 1000);

    const currentDate = new Date();
    const lastDayOfPreviousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
    const endUnixTimestamp = Math.floor(lastDayOfPreviousMonth.getTime() / 1000) + 86400 - 1;

    var startDate = startUnixTimestamp
    var endDate = endUnixTimestamp
    if(this.activeBtn != 'month'){
      this.store.dispatch({
        type:loadCampaignReport.type,
        payload:{
          token:this.sharedService.token,
          startDate,
          endDate
        }
      })
    }

    this.activeBtn = 'month'
  }

  getCampaignsLastYear(){

    var currentDate = new Date()
    var startDate = Math.floor(new Date(currentDate.getFullYear() - 1, 0, 1).getTime()/1000)
    var endDate = Math.floor(new Date(new Date(currentDate.getFullYear() - 1, 11, 31)).setHours(0,0,0)/1000 + 24*60*60 - 1)

    if(this.activeBtn != 'year'){
      this.store.dispatch({
        type:loadCampaignReport.type,
        payload:{
          token:this.sharedService.token,
          startDate,
          endDate
        }
      })
    }

    this.activeBtn = 'year'
  }

  onCampaignReportClick(){
   this.router.navigateByUrl('/reports/campaign')
  }

  onCreateCampaignClick(){ 
    this.router.navigateByUrl('/campaign/select-type');
  }

  getAmountDisplay(amount) {
    return this.dashboardService.addCommasToNumber(amount)
  }

  ngAfterContentInit() {
  }

}
